import React from "react";
import { Dialog, CircularProgress } from "@mui/material";
import LocalFireDepartmentOutlinedIcon from "@mui/icons-material/LocalFireDepartmentOutlined";
import CloseIcon from "@mui/icons-material/Close";
import "./HistoricFiresModal.css";

const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("fr-FR") : null;

const formatHectares = (m2) => {
  const n = Number(m2);
  return Number.isFinite(n) ? `${(n / 10000).toFixed(1)} ha` : null;
};

const HistoricFiresModal = ({ open, onClose, fires, selectedId, onSelect }) => {
  const { data, isLoading, error } = fires;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      slotProps={{
        paper: { className: "hf-paper" },
        backdrop: { className: "hf-backdrop" },
      }}
    >
      <div className="hf-head">
        <span className="hf-head__icon">
          <LocalFireDepartmentOutlinedIcon />
        </span>
        <div className="hf-head__titles">
          <h2>Feux historiques</h2>
          <small>
            {!isLoading &&
              !error &&
              `${data.length} feu${data.length > 1 ? "x" : ""} disponible${data.length > 1 ? "s" : ""}`}
          </small>
        </div>
        <button
          type="button"
          className="hf-close"
          onClick={onClose}
          aria-label="Fermer"
        >
          <CloseIcon fontSize="small" />
        </button>
      </div>

      <div className="hf-body">
        {isLoading && (
          <div className="hf-state">
            <CircularProgress size={28} className="hf-spinner" />
            Chargement des feux historiques…
          </div>
        )}

        {!isLoading && error && (
          <div className="hf-state hf-state--error">{error}</div>
        )}

        {!isLoading && !error && data.length === 0 && (
          <div className="hf-state">Aucun feu historique disponible.</div>
        )}

        {!isLoading &&
          !error &&
          data.map((fire) => {
            const date = formatDate(fire.date);
            const area = formatHectares(fire.area_m2);
            return (
              <button
                type="button"
                className={`hf-item ${fire.id === selectedId ? "hf-item--selected" : ""}`}
                key={fire.id}
                onClick={() => onSelect(fire)}
              >
                <div className="hf-item__top">
                  <strong className="hf-item__label">{fire.label}</strong>
                  {area && <span className="hf-item__area">{area}</span>}
                </div>
                {fire.commune && (
                  <span className="hf-item__commune">
                    {fire.commune.trim()}
                  </span>
                )}
                <div className="hf-tags">
                  {date && <span className="hf-tag">{date}</span>}
                  {fire.nature && (
                    <span className="hf-tag hf-tag--nature">{fire.nature}</span>
                  )}
                </div>
              </button>
            );
          })}
      </div>
    </Dialog>
  );
};

export default HistoricFiresModal;
